<template>
    <transition name="modal">
      <modal v-if="showModal" @modal-close="modalClose()" modal-type="primary" is-close="true">
        <template v-if="modalType == 'register'">
            <modalRegister @modal-close="modalClose" @modal-open="modalOpen('log-in', $event)"></modalRegister>
        </template>
        <template v-else-if="modalType == 'log-in'">
            <modalLogin @modal-show="modalShow('send-email', $event)" @modal-close="modalClose" @modal-open="modalOpen('register', $event)"></modalLogin>
        </template>
        <template v-else-if="modalType == 'send-email'">
            <modalSendEmail @modal-close="modalClose" @modal-open="modalOpen('log-in', $event)"></modalSendEmail>
        </template>
      </modal>
    </transition>
</template>

<script>
import Modal from '@/components/Modal.vue'
import ModalLogin from '@/components/UserAuth/UserAuthModalLogin.vue'
import ModalRegister from '@/components/UserAuth/UserAuthModalRegister.vue'
import ModalSendEmail from '@/components/UserAuth/UserAuthModalSendEmail.vue'
import {UserInfoConfig} from '@/config'
import {popupOpenLogIn} from '@/temporary-code/popup-log-in-open'

export default {
  components: {
    Modal,
    ModalLogin,
    ModalRegister,
    ModalSendEmail
  },

  data () {
    return {
      showModal: false,
      modalType: null,
      linkAccount: UserInfoConfig.linkAccount
    }
  },

  created () {
    popupOpenLogIn(this)
  },

  methods: {
    modalOpen (name, event) {
      event.preventDefault()

      this.showModal = true
      this.modalType = name
    },

    modalShow (name, event) {
      this.showModal = true
      this.modalType = name
    },

    modalClose () {
      this.showModal = false
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserAuth/UserAuth.vue